import React from 'react';
import { Row, Col, Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import getLangData from '../../../utils/getLangData';
const EmptyPage = ({ title, imageName = 'browse.svg', link='/jobs/my-apply' }) => {
  console.log(title, 'artisanJobs')
  return (
    <Row className="p-10">
      <Col sm='12' style={{ height: '400px' }} className='d-flex  mt-3'>
        <img
          className='mx-auto'
          src={require(`../../../assets/images/svg/${imageName}`)}
        />
      </Col>
      {title && (
        <Col className='d-flex mt-3'>
          <div className='mx-auto'>
            <Link to={link} className='btn btn-primary'>
              {title}
            </Link>
          </div>
        </Col>
      )}
    </Row>
  );
};

export default EmptyPage;
